import Checkbox from '@mui/material/Checkbox';
import Container from '@mui/material/Container';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { Controller, useFormContext } from 'react-hook-form';

import { Message } from 'components';
import { LoaderButton } from 'components/ProgressButton';

import { styles } from '../styles';

import PlanTypeInput from './PlanTypeInput';

const UserPaymentFormWrapper = ({ isRenewForm, plans, loading, children }) => {
	const { control } = useFormContext();

	return (
		<Container component="main" maxWidth="lg" sx={styles.container} id="form-container">
			<Grid container spacing={1}>
				<Grid item xs={12}>
					<Controller
						name="plan_type"
						control={control}
						render={({ field, fieldState: { error } }) => (
							<PlanTypeInput error={error} field={field} isRenewForm={isRenewForm} plans={plans} />
						)}
					/>

					<FormControl variant="filled" sx={styles.field}>
						<Controller
							name="first_name"
							control={control}
							render={({ field, fieldState: { error } }) => (
								<TextField
									{...field}
									variant="filled"
									label="First Name"
									error={Boolean(error)}
									helperText={error?.message}
								/>
							)}
						/>
					</FormControl>

					<FormControl variant="filled" sx={styles.field}>
						<Controller
							name="last_name"
							control={control}
							render={({ field, fieldState: { error } }) => (
								<TextField
									{...field}
									variant="filled"
									label="Last Name"
									error={Boolean(error)}
									helperText={error?.message}
								/>
							)}
						/>
					</FormControl>
				</Grid>

				<Grid item xs={12} md={6}>
					<FormControl variant="filled" sx={styles.field}>
						<Controller
							name="email"
							control={control}
							render={({ field, fieldState: { error } }) => (
								<TextField
									{...field}
									variant="filled"
									label="Email Address"
									error={Boolean(error)}
									helperText={error?.message}
									inputProps={{ readOnly: !isRenewForm }}
								/>
							)}
						/>
					</FormControl>
				</Grid>

				<Grid item xs={12} md={6}>
					<Controller
						name="save_card_information"
						control={control}
						render={({ field }) => (
							<FormControlLabel
								sx={{ marginLeft: 0 }}
								control={<Checkbox {...field} defaultChecked />}
								label="Save Card Information"
							/>
						)}
					/>
				</Grid>

				{children}

				<LoaderButton
					type="submit"
					variant="contained"
					color="primary"
					circleColor="secondary"
					loading={loading}
				>
					{isRenewForm ? 'Process Payment' : 'Subscribe to MemberCenter'}
				</LoaderButton>
				<Message />
			</Grid>
		</Container>
	);
};

export default UserPaymentFormWrapper;
